module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainWeb"
  }, [_c('el-dialog', {
    attrs: {
      "title": "阈值设置",
      "visible": _vm.showyuzhi,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showyuzhi = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("私教课名称：" + _vm._s(_vm.yuzhiObj.courseName))]), _vm._v(" "), _c('el-form', {
    ref: "formparamsYuzhi",
    attrs: {
      "model": _vm.formparamsYuzhi,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "提前提醒剩余次数",
      "prop": "minvalue"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入提前提醒次数"
    },
    model: {
      value: (_vm.formparamsYuzhi.minvalue),
      callback: function($$v) {
        _vm.$set(_vm.formparamsYuzhi, "minvalue", _vm._n($$v))
      },
      expression: "formparamsYuzhi.minvalue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "过期提前提醒天数",
      "prop": "expireMinValue"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入过期提前提醒天数"
    },
    model: {
      value: (_vm.formparamsYuzhi.expireMinValue),
      callback: function($$v) {
        _vm.$set(_vm.formparamsYuzhi, "expireMinValue", _vm._n($$v))
      },
      expression: "formparamsYuzhi.expireMinValue"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetFormYuzhi('formparamsYuzhi')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitFormYuzhi('formparamsYuzhi')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "私教信息",
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "私教课价格",
      "prop": "actualPrice"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入私教课价格"
    },
    model: {
      value: (_vm.formparams.actualPrice),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "actualPrice", $$v)
      },
      expression: "formparams.actualPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "任课教练",
      "prop": "jid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.jid),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "jid", $$v)
      },
      expression: "formparams.jid"
    }
  }, _vm._l((this.optionsJL), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上课教室"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.classRoom),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "classRoom", $$v)
      },
      expression: "formparams.classRoom"
    }
  }, _vm._l((this.roomList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "私教课类型",
      "prop": "mode"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "私教课类型（1V2/1V3 传1、2、3、4）",
      "maxlength": "20"
    },
    model: {
      value: (_vm.formparams.mode),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "mode", _vm._n($$v))
      },
      expression: "formparams.mode"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否可选择购买数量",
      "label-width": "140px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "是",
      "inactive-text": "否"
    },
    model: {
      value: (_vm.formparams.changeVariable),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "changeVariable", $$v)
      },
      expression: "formparams.changeVariable"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.formparams.changeVariable == '1') ? _c('el-form-item', {
    attrs: {
      "label": "是否可减少",
      "label-width": "140px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "是",
      "inactive-text": "否"
    },
    model: {
      value: (_vm.formparams.minus),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "minus", $$v)
      },
      expression: "formparams.minus"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.formparams.changeVariable == '1') ? _c('el-form-item', {
    attrs: {
      "label": "是否可增加",
      "label-width": "140px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "是",
      "inactive-text": "否"
    },
    model: {
      value: (_vm.formparams.addUp),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "addUp", $$v)
      },
      expression: "formparams.addUp"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "一次购买节数",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入一次购买节数"
    },
    model: {
      value: (_vm.formparams.limitNum),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "limitNum", $$v)
      },
      expression: "formparams.limitNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提前可预约天数",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入提前可预约天数"
    },
    model: {
      value: (_vm.formparams.appointmenttime),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "appointmenttime", $$v)
      },
      expression: "formparams.appointmenttime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "取消预约时间类型",
      "label-width": "130px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.cancleTimeType),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "cancleTimeType", $$v)
      },
      expression: "formparams.cancleTimeType"
    }
  }, _vm._l((this.timetypes2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "取消预约时长"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入取消预约时长"
    },
    model: {
      value: (_vm.formparams.canceltime),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "canceltime", $$v)
      },
      expression: "formparams.canceltime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程说明",
      "prop": "courseDetails"
    }
  }, [_c('editor-bar', {
    attrs: {
      "isClear": _vm.isClear
    },
    model: {
      value: (_vm.formparams.courseDetails),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "courseDetails", $$v)
      },
      expression: "formparams.courseDetails"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableDataOn,
      "height": "68vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "infI.name",
      "label": "私教课程名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm._f("changeType")(scope.row.shopNum)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "infE.name",
      "label": "教练名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actualPrice",
      "label": "价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "classRoom",
      "label": "教室"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "私教课类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("1v" + _vm._s(scope.row.mode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "私教课说明"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top",
            "width": "300px"
          }
        }, [_c('p', {
          staticStyle: {
            "width": "300px"
          },
          domProps: {
            "innerHTML": _vm._s(scope.row.courseDetails)
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('el-tag', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("鼠标放上查看详情")])], 1)])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "240",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isWeb == 1),
            expression: "scope.row.isWeb==1"
          }],
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeList(scope.row, 0)
            }
          }
        }, [_vm._v("下架")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isWeb == 0),
            expression: "scope.row.isWeb==0"
          }],
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.removeList(scope.row, 1)
            }
          }
        }, [_vm._v("上架")])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5676c41c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/coach/onlineCoach.vue
// module id = 604
// module chunks = 70